import { useRouter } from 'found';
import React from 'react';
import { makeMutation } from '../../../../api/helpers';
import { OnboardMerchant as OnboardMerchantMutation } from '../../../../api/mutations';
import ContentCenterer from '../../../../components/ContentCenterer';
import Button from '../../../../components/input/Button';
import Spacer from '../../../../components/Spacer';
import {
  NormalText,
  PageTitle,
  Paragraph,
  ParagraphLink,
} from '../../../../components/typography/Typography';
import { Buttons } from '../Buttons';
import { useToastDispatch } from '../../../../components/Toast/ToastProvider';
import { mutationsOnboardMerchantMutationVariables } from '../../../../api/__generated__/mutationsOnboardMerchantMutation.graphql';
import { getCurrentAccount } from '../../../../account_helpers';
import styled from 'styled-components';
import { routes } from '../../../../routes';
import Checkbox from '../../../../components/input/Checkbox';
import { setPartnerStatus } from '../../../../helpers';

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

const CheckContainer = styled.div`
  display: flex;
  align-items: center;
`;

function OnboardMerchant() {
  const { router } = useRouter();
  const dispatch = useToastDispatch();
  const [checked, setChecked] = React.useState(false);

  // onClose go back to previous page
  const onClose = () => {
    router.go(-1);
  };

  const onSave = async () => {
    const accountID = getCurrentAccount();
    if (!accountID) {
      dispatch({
        text: `Unable to onboard merchant, please contact support`,
        alert: 'error',
      });
      return;
    }

    if (!checked) {
      dispatch({
        alert: 'warning',
        text: 'Please agree to the Terms and Conditions to continue',
        stayFor: 4000,
      });
      return;
    }

    const variables: mutationsOnboardMerchantMutationVariables = {
      accountID: accountID,
    };

    try {
      await makeMutation(OnboardMerchantMutation, variables);
      dispatch({
        text: `Merchant account created`,
        alert: 'success',
      });
      setPartnerStatus(true);
      router.push(routes.apis);
    } catch (err) {
      dispatch({ text: err.toString(), alert: 'error', stayFor: 4000 });
    }
  };

  return (
    <Container>
      <ContentCenterer maxWidth={'838px'} topMargin>
        <PageTitle>Sell with PayPI</PageTitle>
        <Spacer vertical spacing={2} />
        <NormalText>
          Setup your account to create APIs and take payments.
        </NormalText>
        <Spacer vertical spacing={2} />
        <CheckContainer
          onClick={() => {
            setChecked(!checked);
          }}
        >
          <Checkbox selected={checked} />
          <Spacer horizontal spacing={2} />
          <Paragraph>
            I am an individual or business in a{' '}
            <ParagraphLink target='_blank' href='https://partner.paypi.dev'>
              supported country{' '}
            </ParagraphLink>
            and agree to become a Partner and to PayPI’s{' '}
            <ParagraphLink
              href='https://docs.paypi.dev/legal/terms-and-conditions'
              target='_blank'
            >
              Terms and Conditions
            </ParagraphLink>{' '}
            relating to Partners
          </Paragraph>
        </CheckContainer>
        <Spacer vertical spacing={4} />
        <Buttons>
          <Button background={'#bab8c5'} color={'white'} onClick={onClose}>
            Cancel
          </Button>
          <Button color={'white'} onClick={onSave}>
            Setup
          </Button>
        </Buttons>
      </ContentCenterer>
    </Container>
  );
}

export default OnboardMerchant;
